import * as React from "react";
import type { SVGProps } from "react";
const SvgAppartmentBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 8H9c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1M14 8h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.55 0-1 .45-1 1s.45 1 1 1M10 11H9c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1M14 11h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.55 0-1 .45-1 1s.45 1 1 1M10 14H9c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1M14 14h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.55 0-1 .45-1 1s.45 1 1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 22h-5c-.55 0-1-.45-1-1v-3h-2v3c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1m-4-2h3V4H6v16h3v-3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAppartmentBuilding;
